import {Chip, IconButton, Tooltip, Typography} from "@material-tailwind/react";
import {ChevronUpDownIcon} from "@heroicons/react/24/outline";
import {PencilIcon} from "@heroicons/react/24/solid";
import React, {useContext} from "react";
import Dict from "../../helper/dict";
import {ServiceContext} from "./service_context";
import persianNumberFormat from "../../helper/PersianNumberFormat";


const TABLE_HEAD = ["#", "عنوان", "توضیحات", "وضعیت", "عملیات"];

export function ServiceDocumentGrid({serviceDocuments}) {

  const {setDocument, setStep} = useContext(ServiceContext);

  return (
    <div className="overflow-x-scroll">
      <table className="mt-4 text-left w-full">
        <thead>
        <tr>
          {TABLE_HEAD.map((head, index) => (
            <th key={head}
                className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
              <Typography variant="small" color="blue-gray"
                          className="flex items-center justify-between gap-2 font-normal leading-none opacity-70 flex justify-center">
                {head}{" "}
                {index !== TABLE_HEAD.length - 1 && (
                  <ChevronUpDownIcon strokeWidth={2} className="h-4 w-4 sticky "/>
                )}
              </Typography>
            </th>
          ))}
        </tr>
        </thead>
        <tbody className="textCenter">
        {serviceDocuments.map(
          ({id, title, description, status}, index) => {
            const isLast = index === serviceDocuments.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div
                    className="flex justify-center px-4 hover:cursor-pointer overflow-x-clip md:hover:overflow-x-visible">
                    <Typography color="blue-gray" className="textRight">
                      {description}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Chip className="textRight" variant="ghost"
                          value={Dict(status)}
                          color={status === "accepted" ? "teal" : status === "rejected" ? "red" : status === "new" ? "cyan" : status === "upload" ? "purple" : "red"}/>
                  </div>
                </td>

                <td className={classes}>
                  <Tooltip content="ویرایش">
                    <IconButton variant="text" className="text-align=right" onClick={() => {
                      setDocument(serviceDocuments[index]);
                      setStep("documentation")
                      // setModalOpen(true);
                    }}>
                      <PencilIcon className="h-4 w-4"/>
                    </IconButton>
                  </Tooltip>
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}